/* @ngInject */
class Enquiries {
	constructor($http) {
		this.$http = $http;
	}

	get(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesRegions(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries/summaries/regions`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesReasonsNotReferred(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries/summaries/reasons-not-referred`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesAllFunders(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries/summaries/all-funders`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesNDIS(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries/summaries/ndis`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getSummariesIcare(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries/summaries/icare`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}

	getIndividualsEnquiries(start, end) {
		return this.$http.get(
			`${process.env.API_ENDPOINT}staff/reports/enquiries/individuals/enquiries`, {
				params: {
					start: start,
					end:   end,
				},
			},
		);
	}


	getCaseManagers() {
		return this.$http.get(`${process.env.API_ENDPOINT}staff/reports/enquiries/case-managers`);
	}
}

export default Enquiries;


// WEBPACK FOOTER //
// ./src/js/services/staff/reports/enquiries/index.js